import { useEffect, useState } from "react"
import { CONFIG } from '../../../constants/backendUrl'
import './Translate.css'
import { Button, Flex, Popover } from "antd"

import USA from '../../../assets/flags/USA.png';
import RUS from '../../../assets/flags/Russia.png';
import KAZ from '../../../assets/flags/Kazakh.png';

export function Translate(props) {

	const [currentLang, setCurrentLang] = useState({ value: "", label: "Русский" })
	function deleteCookie(name) {
		const date = new Date();
		date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
		document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/";
	}
	const setTranslate = (value) => {
		document.cookie = `googtrans=${value} domain=${CONFIG.appDomain}; path=/;`
		document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.asista.kz; path=/;`;
		if (value === "") {
			deleteCookie("googtrans");
		}
		window.location.reload();
	};
	useEffect(() => {
		const script = document.createElement('script');
		script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
		document.body.appendChild(script);
		window.googleTranslateElementInit = () => {
			new window.google.translate.TranslateElement(
				{
					pageLanguage: 'ru',
					includedLanguages: 'kk,en',
					autoDisplay: false,
				},
				'google_translate_element'
			);
		};

	}, []);
	useEffect(() => {
		const getAllCookies = () => {
			const cookieObj = document.cookie.split(';')
				.map(cookie => cookie.split('='))
				.reduce((accumulator, [key, value]) => ({ ...accumulator, [key.trim()]: decodeURIComponent(value) }), {});

			if (cookieObj.googtrans) {
				if (cookieObj.googtrans.substring(4, 6) === "en") {
					setCurrentLang({ value: "en", label: "English" })
				}
				if (cookieObj.googtrans.substring(4, 6) === "kk") {
					setCurrentLang({ value: "kk", label: "Қазақ" })
				}
			}
		};
		getAllCookies();
		setInterval(getAllCookies, 1000); // Check every 1 second
	}, []);

	const flags = {
		'Русский': {
			icon: RUS,
			title: 'Выберите язык'
		},
		'English': {
			icon: USA,
			title: 'Select Language'
		},
		'Қазақ': {
			icon: KAZ,
			title: 'Тілді таңдаңыз'
		}
	}

	const options = [
		{ value: "/ru/kk", label: "Қазақ" },
		{ value: "/ru/en", label: "English" },
		{ value: "", label: "Русский" }
	]

	return (
		<div className='Translate'>
			<div>
				<div id="google_translate_element"></div>
				<div className="notranslate">
					<Flex gap={5}>
						{
							flags[currentLang.label] &&
							<Popover
								title={flags[currentLang.label].title}
								trigger='click'
								content={
									<Flex vertical gap={5}>
										{options.map(option => (
											<Button
												type='text'
												style={{ justifyContent: "flex-start" }}
												key={option.value}
												onClick={() => setTranslate(option.value)}
												icon={props.hideFlags ? null : <img style={{ width: 25 }} src={flags[option.label]?.icon} alt={option.label} />}
											>
												{option.label}
											</Button>
										))}
									</Flex>
								}
							>
								<Button
									icon={props.hideFlags ? null : <img style={{ width: 24, paddingTop: 4 }} src={flags[currentLang.label].icon} alt={currentLang.label} />}
								>
									{props?.hideLabel ? '' : currentLang.label}
								</Button>
							</Popover>
						}
					</Flex>
				</div>
			</div>
		</div>
	);
}